import { render, staticRenderFns } from "./linkedMatchLogInfo.vue?vue&type=template&id=4475d7b0&scoped=true&lang=pug&"
import script from "./linkedMatchLogInfo.vue?vue&type=script&lang=js&"
export * from "./linkedMatchLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475d7b0",
  null
  
)

export default component.exports